import React, {Fragment, useEffect, useState} from 'react';
import moment from "moment";
import CUFormService from "../../../../services/CUFormService";
import FormService from "../../../../services/FormsService";
import Color from "color";

const TemplateCUBSignature = (props) => {

    const [entity, setEntity] = useState({name:'', email:'', phone:'', cp:'', city: '', address:'', address2:'', stamp:''})
    const cuFormService = new CUFormService();
    const formService = new FormService();
    const [imgBase64, setImgBase64] = useState();
    const [annexes, setAnnexes] = useState();

    useEffect(()=>{
        setEntity(cuFormService.getEntityInfo())
        setAnnexes(formService.getEntityAnnexes())
    }, [])

    useEffect(()=>{

    }, [annexes])

    useEffect( ()=>{

    },[entity])

    const ImgLinktoDataURL =(url)=>{
        let xhr = new XMLHttpRequest();
        xhr.onload = function() {
            var reader = new FileReader();
            reader.onloadend = function() {
                setImgBase64(reader.result)
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    return (
        <div className="ue-section">
             <div className="col-12">
                    <div className={'ru-signature'} style={{"minHeight": "350px"}}>
                        <table style={{"width":"100%"}} >
                            <tbody>
                            <tr>
                                <td  style={{"verticalAlign": "middle", "textAlign":"right", "marginRight":"5px"}} width='50%'>
                                    <div className="ru-form-stamp ">
                                        {
                                            (entity.stamp && entity.stamp != '')?
                                                <img src={imgBase64} alt="tempon" width={130}/>
                                                :null
                                        }
                                    </div>
                                </td>
                                <td style={{"textAlign":"left"}}>
                                    <p className={'font-italic'}>
                                        Fait à : {entity.city} le : {moment().format("DD/MM/YYYY")}
                                    </p>
                                    <p>Le Maire,</p>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <br/>
                    </div>
                </div>
        </div>
    );
};

export default TemplateCUBSignature;
